/* template */
<template><div :class="({      'good-card-wrapper': true,      'shadow': shadow,      'auto-size': autoSize    })"><div :class='"good-card"'><div class="card-fixed-content" v-if="(showRechargePhone && goodInfo.send_cell)">账号: {{goodInfo.send_cell}}</div><mpx-view :class='"card-left-content"' :style="(contentStyle)" @tap="onClick('left')" v-if="(leftType === 'img')"></mpx-view><card-left-content :title="(title)" :useDesc="(true)" :carTypeList="(carTypeList)" :desc="(desc)" :picture="(picture)" :inProgress="(inProgress)" :activity-type="(activityType)" :current-time="(currentTime)" :instance-end-time="(instanceEndTime)" :group-show-tag="(groupShowTag)" :bogo-limit="(bogoLimit)" :is-spike="(goodInfo.is_spike)" :is-order="(isOrder)" :is-diff-price="(isDiffPrice)" :balance="(balance)" :balance-left="(balanceLeft)" :recommend-toast="(recommendToast)" :leftType="(leftType)" @onClick="onClick('left')" v-else/><card-center-content :packages="(packages)" :currency="(goodInfo.currency)" :special-text="(specialText)" :goods-type="(goodInfo.goods_type)" :product-type="(goodInfo.product_type)" @onClick="onClick('center')" :package-is-fixed-price="(packageIsFixedPrice)" class="card-center-content_b"/><card-right-content :in-progress="(inProgress)" :activity-type="(activityType)" :group-person="(groupPerson)" :bogo-count="(bogoCount)" :is-order="(isOrder)" :price="(price)" :suffix="(suffix)" :currency="(goodInfo.currency)" :order-time="(goodInfo.create_time)" :status-name="(goodInfo.status_name)" :total-save="(totalSave)" :pre-sale="(preSale)" :sold-out="(soldOut)" :showGoodsUsage="(showGoodsUsage)" @onClick="onClick('right')" @subtarClick="subtarClick" :package-is-fixed-price="(packageIsFixedPrice)" class="order-right"/></div><div class="another"><div class="useful-tips" v-if="(usefulTips)">{{disableTime}}</div><mpx-view @tap="anotherOrder" class="another-order" v-if="(canAnotherOrder)">再来一单</mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m27e1a7cd"}'>
.good-card-wrapper
  position relative
  width 681rpx
  margin-bottom 30rpx
  padding 50rpx 8rpx 21rpx
  display flex
  flex-direction column
  justify-content flex-start
  align-items stretch
  background #FFFFFF
  background-image linear-gradient(149deg, #FFFFFF 0%, #FDFBF7 99%)
  border-radius 20rpx
  &.auto-size
    width 100%
    height 100%
  &.shadow
    box-shadow 0 10rpx 20rpx 0 rgba(220, 220, 220, 0.49)
.good-card
  height 183rpx
  margin-bottom 10rpx
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items stretch
  .card-fixed-content {
    position absolute
    top 15rpx
    // left: 256rpx
    left 7rpx
    font-size 20rpx
    color #010101
    text-align left
    line-height 1.4
  }
.another
  display flex
  flex-direction column
  align-items flex-end
  .useful-tips
    box-sizing border-box
    width 686rpx
    height 26rpx
    line-height 26rpx
    margin 0 auto 19rpx
    padding-left 8rpx
    margin-bottom 19rpx
    background #FFBC98
    opacity 0.5
    font-size 17rpx
    font-family PingFang SC
    font-weight 400
    color #FF6C00
  .another-order
    width fit-content
    height 45rpx
    line-height 45rpx
    padding 0 13rpx
    margin-right 30rpx
    background #ffffff
    border 2rpx solid #FF9358
    box-shadow 3rpx 4rpx 8rpx 0rpx rgba(158,158,158,0.57)
    border-radius 10rpx
    color #FF6C00
    font-size 24rpx
    font-family PingFang SC
    font-weight 400
    cursor pointer
.card-center-content_b
  flex auto
.order-right
  margin-right 27rpx
.card-left-content
  position relative
  width 231rpx
  height 100%
  box-sizing border-box
  padding 32rpx 0 0 20rpx
  border-radius 20rpx
  background-size cover
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { goodCardMixins } from '@didi/trade-sdk/lib/quartz/mixins/good_card.js'
import { timestamp2ymdhms } from '@didi/trade-sdk'
import { navigateToWebx } from '../../lib/js/navigateTo'
import { GlobalEnv } from '../../lib/webx'
import { mallTrackStd } from '../../lib/webx/common_methods/track.js'
import { utils } from '@didi/webx-js'
createComponent({
  name: 'GoodCard',
  mixins: [ goodCardMixins ],
  properties: {
    // 逻辑
    inProgress: {
      type: Boolean,
      value: false,
    },
    // 是否是订单页面
    isOrder: {
      type: Boolean,
      value: false,
    },
    // 商品信息， 接口返回原始数据
    goodInfo: Object,
    // 阴影样式
    shadow: {
      type: Boolean,
      default: false,
    },
    // 展示购买手机号
    showRechargePhone: {
      type: Boolean,
      default: false,
    },
    // 展示商品使用说明
    showGoodsUsage: {
      type: Boolean,
      default: false,
    },
    // 自适应尺寸
    autoSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    leftType() {
      return (this.goodInfo?.partition_id === 1105 && this.goodInfo?.extra?.goods_create_time > 1695139199) ? 'img' : 'comp' // 抖音渠道商品-晚于2023-9-19 23:59:59时间戳（s）创建的商品只展示商品图
    },
    contentStyle() {
      return this.picture ? {
        backgroundImage: `url(${utils.webpUrl(this.picture) })`,
      } : {}
    },
    // 展示有效期提示
    usefulTips() {
      const statusArr = [ 1, 5 ] // 购买成功staus 1,5
      const status = this.goodInfo?.status
      return statusArr.includes(status) && this.goodInfo?.available_coupon_number > 0
    },
    // 是否支持再来一单
    canAnotherOrder() {
      return this.goodInfo?.can_another_order
    },
    // 订单截止时间
    disableTime() {
      const {
        year,
        month,
        date,
        hour,
        minute,
        second,
      } = timestamp2ymdhms(this.goodInfo?.disable_time * 1000)
      return `有效期截止 ${year}.${month}.${date} ${hour}.${minute}.${second}，请尽快使用哦`
    },
  },
  methods: {
    anotherOrder() {
      mallTrackStd('wyc_trippackage_order_more_ck', '套餐_历史购买页再来一单点击', {
          order_status: this.goodInfo.order_status,
          goods_id: this.goodInfo.goods_id, // 商品id
          goods_order_id: this.goodInfo.id, // 商品成交id
        })
        navigateToWebx({
          pathname: 'orderConfirm',
          query: {
            another_order: 'another_order',
            id: this.goodInfo.goods_id,
          },
          openPage: !!GlobalEnv.atDidao,
        })
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "good_card27e1a7cd",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'card-right-content':getComponent(require("./order_info_dy.mpx?component=true&componentId=order_info_dy93a20e60")),'card-center-content':getComponent(require("../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/components/card_center_content/index.mpx?component=true&componentId=index24652d45")),'card-left-content':getComponent(require("../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/components/card_left_content/index.mpx?component=true&componentId=index45017377")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
